import { Component, Input, OnInit } from '@angular/core';
import { Mimetype } from 'src/app/models/defines';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { VgApiService } from '@videogular/ngx-videogular/core';

@Component({
    selector: 'dynamic-asset-content',
    templateUrl: './dynamic-asset-content.component.html',
    styleUrls: ['./dynamic-asset-content.component.scss'],
})
export class DynamicAssetContentComponent implements OnInit {
    @Input({ alias: 'item', required: true })
    item!: Partial<{ uploadPath: string; mimeType?: Mimetype | null; dashPath?: string; thumbSrc?: string }>;

    fileMimetype: Mimetype;
    MimetypeEnum = Mimetype;
    fileSrc: string;
    vgApi!: VgApiService;
    baseCdnUrl: string;

    isImage: boolean = false;
    isVideo: boolean = false;
    isSVG: boolean = false;

    constructor(
        private sanitizer: DomSanitizer,
        private config: ConfigurationService
    ) {
        this.baseCdnUrl = this.config.baseCdnUrl;
    }

    ngOnInit(): void {
        // console.log('why this is happening', this.asset.uploadPath);
        this.fileMimetype = this.item.mimeType;
        if (!this.fileMimetype) {
            /// This will happen in very special cases !
            const fileExt = this.getFileExtension(this.item.uploadPath ?? this.item.thumbSrc);
            switch (fileExt) {
                case 'png':
                    this.fileMimetype = Mimetype.PNG;
                    break;
                case 'gif':
                    this.fileMimetype = Mimetype.GIF;
                    break;
                case 'jpg':
                    this.fileMimetype = Mimetype.JPG;
                    break;
                case 'jpeg':
                    this.fileMimetype = Mimetype.JPEG;
                    break;
                case 'mp4':
                    this.fileMimetype = Mimetype.VIDEO_MP4;
                    break;
                case 'webm':
                    this.fileMimetype = Mimetype.VIDEO_WEBM;
                    break;
                case 'ogg':
                    this.fileMimetype = Mimetype.VIDEO_OGG;
                    break;
                case 'svg':
                    this.fileMimetype = Mimetype.SVG;
                    break;
                default:
                    this.fileMimetype = Mimetype.PNG;
                    break;
            }
        }
        this.fileSrc = decodeURIComponent(this.item.dashPath ?? this.item.uploadPath ?? this.item.thumbSrc);
        // const aa = this.baseCdnUrl + this.fileSrc + '';
        // console.log(`HHHHHIII`, aa);
        this.setAssetType();
    }

    onPlayerReady(api: any) {
        this.vgApi = api;
    }

    getFileExtension(fileUrl: string): string {
        // Split the URL by "." to get an array of segments
        const segments = fileUrl.split('.');

        // The file extension is the last segment
        const fileExt = segments[segments.length - 1].toLowerCase();

        return fileExt;
    }

    setAssetType() {
        if ([Mimetype.PNG, Mimetype.JPG, Mimetype.JPEG, Mimetype.GIF].includes(this.fileMimetype)) {
            return this.setWhichAssetToDisplay(true, false, false);
        }
        if ([Mimetype.VIDEO_MP4, Mimetype.VIDEO_WEBM, Mimetype.VIDEO_OGG].includes(this.fileMimetype)) {
            return this.setWhichAssetToDisplay(false, true, false);
        }
        if (this.fileMimetype === Mimetype.SVG) {
            return this.setWhichAssetToDisplay(false, false, true);
        }
    }

    setWhichAssetToDisplay(isImage: boolean, isVideo: boolean, isSVG: boolean) {
        this.isImage = isImage;
        this.isVideo = isVideo;
        this.isSVG = isSVG;
    }
}
